/**
 * Positions KM header mobile menu flyout directly below the search bar (fixed viewport coords).
 */
(function () {
  const MQ = window.matchMedia('(max-width: 989px)');

  function clearPanels(root) {
    root.querySelectorAll('.km-hm__mobpanel').forEach((panel) => {
      panel.style.removeProperty('top');
      panel.style.removeProperty('max-height');
    });
  }

  function place(root) {
    if (!MQ.matches) {
      clearPanels(root);
      return;
    }

    const search = root.querySelector('.km-hm__search');
    if (!search) return;

    const rect = search.getBoundingClientRect();
    const gap = 10;
    const topPx = Math.round(rect.bottom + gap);
    const maxH = Math.max(160, window.innerHeight - topPx - 16);

    root.querySelectorAll('.km-hm__mobpanel').forEach((panel) => {
      panel.style.top = `${topPx}px`;
      panel.style.maxHeight = `${maxH}px`;
    });
  }

  function bind(root) {
    const run = () => place(root);

    root.querySelectorAll('.km-hm__details--burger').forEach((details) => {
      details.addEventListener('toggle', run);
    });

    window.addEventListener('resize', run);
    window.addEventListener('scroll', run, { passive: true });

    if (typeof MQ.addEventListener === 'function') {
      MQ.addEventListener('change', run);
    } else if (typeof MQ.addListener === 'function') {
      MQ.addListener(run);
    }
    run();
  }

  document.querySelectorAll('[data-km-header-main]').forEach(bind);
})();
